export const NewCard = ({}) => {
    return (
        <div className="new-card-box">
            <p>NEW</p>
        </div>
    );
};
